import React, { Component } from 'react'
const loadMoreResources = () => {
	document.getElementById("moreResources").style.display = "block";
	document.getElementById("loadMoreResources").style.display = "none";
	document.getElementById("loadMoreResources2").style.display = "block";
	document.getElementById("loadLessResources").style.display = "block";
	
}
const loadMoreResources2 = () => {
	document.getElementById("moreResources2").style.display = "block";
	document.getElementById("loadMoreResources2").style.display = "none";
	document.getElementById("loadLessResources2").style.display = "block";
	document.getElementById("loadLessResources").style.display = "none";
	
}
const loadLessResources = () => {
	document.getElementById("moreResources").style.display = "none";
	document.getElementById("loadMoreResources2").style.display = "none";
	document.getElementById("loadLessResources").style.display = "none";
	document.getElementById("loadMoreResources").style.display = "block";
	
}
const loadLessResources2 = () => {
	document.getElementById("loadLessResources").style.display = "block";
	document.getElementById("moreResources2").style.display = "none";
	document.getElementById("loadMoreResources2").style.display = "block";
	document.getElementById("loadLessResources2").style.display = "none";
}

export default class Resources extends Component {
  render() {
    return (
      <div>
		  
				<section className="davidvallejo-work" data-section="resources">
				<h1>Resources</h1>
				<div class="vl"></div>
					<div className="davidvallejo-narrow-content">
						<div className="row">
							<div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
								<span className="heading-meta">Check out</span>
								<h2 className="davidvallejo-heading animate-box">My Resources</h2>
							</div>
						</div>
						<div className="row">
							<div className="col-md-4 animate-box" data-animate-effect="fadeInLeft">
								<div className="project" style={{backgroundImage: 'url(images/img-1.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 01</a></h3>
											<span>Website</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-2.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 02</a></h3>
											<span>Animation</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInTop">
								<div className="project" style={{backgroundImage: 'url(images/img-3.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 03</a></h3>
											<span>Illustration</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div id="moreResources" style={{display: 'none'}}>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInBottom">
								<div className="project" style={{backgroundImage: 'url(images/img-4.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 05</a></h3>
											<span>Application</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInLeft">
								<div className="project" style={{backgroundImage: 'url(images/img-5.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 06</a></h3>
											<span>Graphic, Logo</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInRight">
								<div className="project" style={{backgroundImage: 'url(images/img-6.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 07</a></h3>
											<span>Web Design</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
							<div id="moreResources2" style={{display: 'none'}}>
							<div className="col-md-4 animate-box" data-animate-effect="fadeInBottom">
								<div className="project" style={{backgroundImage: 'url(images/img-4.jpg)'}}>
									<div className="desc">
										<div className="con">
											<h3><a href="work.html">Work 08</a></h3>
											<span>Application</span>
											<p className="icon">
												<span><a href="#"><i className="icon-share3" /></a></span>
												<span><a href="#"><i className="icon-eye" /> 100</a></span>
												<span><a href="#"><i className="icon-heart" /> 49</a></span>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						</div>
						</div>
						<div className="row" id="buttons">
							<div className="col-md-4 animate-box">
							<button id="loadMoreResources" class="big-button" onClick={loadMoreResources} style={{display: 'block'}}>Load more <i className="icon-plus-outline" /></button>
							<button id="loadMoreResources2" class="big-button" onClick={loadMoreResources2} style={{display: 'none'}}>Load more <i className="icon-plus-outline" /></button>
							
							</div>
							<div className="col-md-4 animate-box">
							<button id="loadLessResources" class="big-button" onClick={loadLessResources} style={{display: 'none'}}>Load Less <i className="icon-minus-outline" /></button>
							<button id="loadLessResources2" class="big-button" onClick={loadLessResources2} style={{display: 'none'}}>Load Less<i className="icon-minus-outline" /></button>
							</div>
						</div>
					</div>
				</section>
      </div>
    )
  }
}
